import React from 'react'
import MenuItem from './MenuItem'

const DesktopMenu = ({ menuItems }) => {
  return (
    <nav className="greyRow menu-column">
      <ul className="menu-items">
        {menuItems?.map?.(item => (
          <MenuItem item={item} key={item?.id} />
        ))}
      </ul>
    </nav>
  );
};

export default DesktopMenu;